import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import useStore from "stores";

import VopHeader from "components/vop_header";
import VopFooter from "components/vop_footer";
import HomeHeader from "components/HomeHeader"
import FeedBack from "components/vop_feedback";
import SurveyInfo from "components/vop_surveyInfo";
import { loginUrl } from "utils/api/ajax";
import { queryClientCase } from "utils/api/index";
import "./style.scss";

const ComponentHome = observer(() => {
  const { loginStore } = useStore();
  const [headerData, setHeaderData] = useState({
    bgColor: "linear-gradient(180deg, rgba(7,7,7,1) 0%,rgba(3,3,3,0) 100%)",
  });
  const [caseData, setCaseData] = useState([]);
  useEffect(()=>{
    document.title = "京东VOP开放平台-门户";
    window.scrollTo(0, 0);
    window.onscroll = () => {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if(scrollTop > 50) {
        setHeaderData({
          bgColor: "#000",
        });
      } else {
        setHeaderData({
          bgColor:
            "linear-gradient(180deg, rgba(7,7,7,1) 0%,rgba(3,3,3,0) 100%)",
        });
      }
    }
    init();
  },[])


  const init =()=> {
    queryClientCase().then(((res)=> {
      const {result, success} = res.data;
      if( success ) {
        // console.log('result', result)
        setCaseData(result)
        // setEmpty(!res.data.result);
      }
    }))
  }

  function handleArticleChange(article) {
    log("VopOpenIndex_1602911919488", '36');
    location.href = `/doc/guide?id=${article}`
  }

  return (
    <div className="component-wrap component-home">
      <div className="component-box">
        <VopHeader {...headerData} contentWidth="1200px">
            <HomeHeader />
        </VopHeader>
      </div>
      <div className="component-box component-banner">
        <img src="https://img12.360buyimg.com/imagetools/jfs/t1/122443/36/29039/1127527/627e40c2E3a4aa471/1d499f96a841a4cd.png!cc_1536x600" />
        <div className="content">
          <h3 className="title">组件化采购解决方案</h3>
          <div className="desc">将采购商城以类似积木的形式，拆解成多个模块化的组件服务。客户通过“嵌入式”实现商城的快速、低成本建设，同时保证数据的协同性。</div>
          <Link 
            className="btn" 
            to={loginStore.isLogin ? "/app/frame" : loginUrl}
            clstag="pageclick|keycount|VopOpenIndex_1602911919488|34" 
          >
            前去订阅
          </Link>
          
        </div>
      </div>
      <div className="component-box component-sence">
        <div className="sence-hd">
          <h4 className="component-title">VOP组件化服务</h4>
          <strong className="sub-title">【低复杂度+低成本+迭代无忧】助力企业高效建设与经营</strong>
          <p className="desc">VOP组件化服务，致力于将复杂的采购流程进行解构，以简单、快捷的形式支持客户接入满足客户降本增效的经营需求，同时保障商城用户高质量的采购体验。</p>
        </div>
        <div className="sence-bd left">
          <div className="content-box">
            <img src="https://storage.360buyimg.com/imgtools/5d3eaff657-45dec9d0-d2a8-11ec-959c-2fe702378bf4.png" />
            <div className="content">
              <h4 className="title">一次性接入、迭代无忧</h4>
              <p className="desc">以较低的研发成本、较低的复杂度，接入一套完整的采购商城功能模块，且后续迭代成本极低。</p>
            </div>
          </div>
        </div>
        <div className="sence-bd right">
          <div className="content-box">
          <div className="content">
              <h4 className="title">低成本+加速开发</h4>
              <p className="desc">利用组件化服务，客户可以实现低成本、快速的搭建一整套相对完整的数字化采购商城。</p>
            </div>
            <img src="https://img10.360buyimg.com/imagetools/jfs/t1/3532/27/17623/290966/62833ef8E770a4397/eb8f5f34c29555f6.png" />
          </div>
        </div>
        <div className="sence-bd left">
          <div className="content-box">
            <img src="https://img14.360buyimg.com/imagetools/jfs/t1/189944/36/25192/272131/62833ef8E09487ae7/4165a61f64eed507.png" />
            <div className="content">
              <h4 className="title">用户体验流畅</h4>
              <p className="desc">通过行业标准化服务，极大提升用户在采购前、采购中、采购后的体验和效率。</p>
            </div>
          </div>
        </div>
      </div>
      <div className="component-box component-construct">
        <h4 className="component-title">组件服务架构</h4>
        <p className="desc">从采购管理到采购后服务，实现全流程搭建的降本增效与高效体验</p>
        <Link 
          className="btn" 
          to="/component/list" 
          clstag="pageclick|keycount|VopOpenIndex_1602911919488|35" 
        >
          查看全部组件
        </Link>
        <div className="img-box">
          <img src="https://img11.360buyimg.com/imagetools/jfs/t1/196931/14/23812/288945/62834a74Eb54517a4/156a3307e9fe9b78.png" />
        </div>
      </div>
      <div className="component-box component-case">
        <h4 className="component-title">客户案例</h4>
        <div className="case-list">
          { caseData.length > 0 && 
            caseData.map((item, index) => {
              return (
                <div 
                  className={`case-item case-item-${index+1}`}
                  key={index}
                  onMouseEnter={() => {
                    // handleMouseEnter(index);
                  }}
                >
                  <div className="content">
                    <i className={`icon icon-${index+1}`}></i>
                    <div className="title">{item.title}</div>
                    <div className="desc">{item.content}</div>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
      <div className="component-box component-support">
        <h4 className="component-title">文档与支持</h4>
        <ul className="support-list">
          <li className="support-item">
            <div 
              onClick={(e) => {
                e.stopPropagation();
                handleArticleChange('6e9fff8c-80d5-4e9c-8c9b-461cb4e25d56');
              }}
            >
              组件化服务介绍
            </div>
          </li>
          <li className="support-item">
            <div 
              onClick={(e) => {
                e.stopPropagation();
                handleArticleChange('a4f1f602-184e-4be0-a902-27f9955cda78');
              }}
            >
              组件对接流程详解
            </div>
          </li>
          <li className="support-item">
            <div 
              onClick={(e) => {
                e.stopPropagation();
                handleArticleChange('511b4d8a-cb3f-4368-885a-995753f07d14');
              }}
            >
              组件对接常见问题
            </div>
          </li>
        </ul>
      </div>
      <div className="jdw-container">
        <div className="jdw-row">
          <div className="jdw-column">
            <div
              className="jdw-widget"
              data-name="vop_footer"
              data-version="2.0.0"
            >
              <VopFooter />
            </div>
          </div>
        </div>
      </div>


      <FeedBack></FeedBack>
      <SurveyInfo></SurveyInfo>

    </div>
  );
});

export default ComponentHome;
